import { useContext, useEffect } from 'react';
import { TableRow } from '../../../../../components/Table';
import { TabsContext } from '../../../../../components/Tabs';
import { EmissionSpoolDto } from '../../../../../context/emissionSpools/emissionSpoolsType';
import useIsMounted from '../../../../../hooks/useIsMounted';
import EmissionSpoolsAccordionRow from './EmissionSpoolsAccordionRow';

type Props = {
    spoolDetails: EmissionSpoolDto;
    collapsed: boolean;
    toggle: (spoolAddress: string) => void;
};

const EmissionSpoolRow: React.FC<Props> = ({ spoolDetails, collapsed, toggle }) => {
    const { updateHeight } = useContext(TabsContext);

    const isMounted = useIsMounted();

    useEffect(() => {
        updateHeight();

        const timeout = setTimeout(() => {
            isMounted();
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [collapsed, updateHeight, isMounted]);

    return (
        <TableRow className={collapsed ? 'collapsed' : ''}>
            <EmissionSpoolsAccordionRow spoolDetails={spoolDetails} />
        </TableRow>
    );
};

export default EmissionSpoolRow;
